import type { ThemeDetail, VolumeType } from '../types';

import type { TableColumnConfig } from '@/shared/components/data-table';

export function getThemeTableColumns(
  sentiment: 'positive' | 'negative',
  volumeType: VolumeType,
): TableColumnConfig<ThemeDetail>[] {
  const volumeKey = volumeType === 'mention' ? 'mention_volume' : 'post_volume';
  const columnTitle = volumeType === 'mention' ? 'Mention' : 'Post volume';
  const sentimentIcon = sentiment === 'positive' ? '👍' : '👎';

  return [
    // 1st Column: Index with sentiment icon
    {
      key: '__index__',
      header: sentimentIcon,
      size: '60px',
      tableCellClassName: 'text-center px-6',
      cell: ({ row, table }) => {
        const pageIndex = table.getState().pagination.pageIndex;
        const pageSize = table.getState().pagination.pageSize;
        const rowModel = table.getRowModel();
        const visualIndex = rowModel.rows.findIndex((r) => r.id === row.id);
        const actualIndex = pageIndex * pageSize + visualIndex + 1;
        return (
          <div className="flex items-center justify-center text-sm font-medium">{actualIndex}</div>
        );
      },
    },
    // 2nd Column: Theme name
    {
      key: 'name',
      header: 'Theme',
      size: '1fr',
      cell: ({ getValue }) => <div className="font-medium">{getValue() as string}</div>,
    },
    // 3rd Column: Sentiment
    {
      key: 'sentiment',
      header: 'Sentiment',
      size: '120px',
      cell: () => (
        <span
          className={`inline-flex items-center rounded-full px-[10px] py-[2px] text-[12px] font-semibold text-[#fbfaf9] ${
            sentiment === 'positive' ? 'bg-[#2a9d90]' : 'bg-red-600'
          }`}
        >
          {sentiment === 'positive' ? 'Positive' : 'Negative'}
        </span>
      ),
    },
    // 4th Column: Volume
    {
      key: volumeKey,
      header: columnTitle,
      size: '120px',
      tableCellClassName: 'text-right px-6',
      cell: ({ getValue }) => {
        const value = getValue() as number;
        return <div className="text-right">{value?.toLocaleString() || '0'}</div>;
      },
    },
  ];
}
